var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63933 4.15252C5.73323 4.05474 5.86058 3.9998 5.99336 3.9998C6.12614 3.9998 6.25348 4.05474 6.34739 4.15252L9.18014 7.10322C9.22796 7.15133 9.26611 7.20889 9.29235 7.27253C9.3186 7.33616 9.33241 7.40461 9.33299 7.47387C9.33357 7.54312 9.3209 7.61181 9.29572 7.67591C9.27054 7.74001 9.23336 7.79825 9.18634 7.84723C9.13932 7.8962 9.08342 7.93493 9.02187 7.96116C8.96033 7.98738 8.8944 8.00058 8.82791 7.99998C8.76142 7.99938 8.69571 7.98499 8.63461 7.95765C8.57352 7.93032 8.51827 7.89058 8.47207 7.84076L5.99336 5.25884L3.51464 7.84076C3.4202 7.93578 3.29371 7.98835 3.16241 7.98716C3.03112 7.98597 2.90553 7.93112 2.81268 7.83441C2.71984 7.7377 2.66718 7.60687 2.66603 7.47011C2.66489 7.33335 2.71537 7.20159 2.80658 7.10322L5.63933 4.15252Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.21a54766e419aa7528f6530e0ca7dfc6.svg";
export { ForwardRef as ReactComponent };